<script>
	import { colors } from './utils.js';

	export let theme = null;

  let style = '';
  let hrstyle = '';

  if (theme) {
    style += ` color: ${colors[theme]['text']}; background-color: ${colors[theme]['background']};`;
    hrstyle += ` color: ${colors[theme]['muted']};`;
  }
</script>

<section style="{style}">
	<div class="col-medium">
		<hr style="{hrstyle}"/>
	</div>
</section>

<style>
  hr {
    width: 65px;
    border: none;
    border-top: 4px dotted;
    margin: 40px auto -10px auto;
  }
</style>

